module.exports = __webpack_public_path__ + "img/formula.21323504.svg";